import { Box, styled } from "@mui/material";

export const ActivityScaleWrapper = styled(Box)({
  boxSizing: "border-box",
  width: "565px",
  height: "75px",
  borderRadius: "16px",
  background: "white",
  padding: "12px",

  boxShadow: "0px 1px 8px -1px rgba(0, 0, 0, 0.2)",

  position: "absolute",
  bottom: "24px",
  right: "24px",
  zIndex: "99",
});

export const Gradient = styled("div")({
  width: "540px",
  height: "28px",
  borderRadius: "4px",
  background: "linear-gradient(0.25turn, #27C57B, #E5E743, #EA0D53)",
});

export const InfoItemsWrapper = styled("div")({
  width: "540px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "55px",
  marginTop: "8px",
});

export const InfoItem = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "6px",
  fontSize: "12px",
});
